// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-splitter > .k-pane {
  height: 100%;
  overflow: hidden;
}

.k-tabstrip-items{
    background-color: var(--grid-header-color) !important;
}

 .k-tabstrip-items-wrapper .k-item.k-active{
  background-color: var(--selecte-row-color) !important;
  color: white !important;
  font-weight:normal !important;
}


.k-tabstrip-items-wrapper .k-item {
    color: var(--selecte-row-color) !important;
    font-weight:bolder;
}

.k-tabstrip-items-wrapper .k-item:hover {
  outline: 2px solid var(--selecte-row-color) !important;
  outline-offset: -3px;
  border-radius: 5px;
}

`, "",{"version":3,"sources":["webpack://./src/components/tabs/tabs.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;IACI,qDAAqD;AACzD;;CAEC;EACC,qDAAqD;EACrD,uBAAuB;EACvB,6BAA6B;AAC/B;;;AAGA;IACI,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;EACE,sDAAsD;EACtD,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":[".k-splitter > .k-pane {\n  height: 100%;\n  overflow: hidden;\n}\n\n.k-tabstrip-items{\n    background-color: var(--grid-header-color) !important;\n}\n\n .k-tabstrip-items-wrapper .k-item.k-active{\n  background-color: var(--selecte-row-color) !important;\n  color: white !important;\n  font-weight:normal !important;\n}\n\n\n.k-tabstrip-items-wrapper .k-item {\n    color: var(--selecte-row-color) !important;\n    font-weight:bolder;\n}\n\n.k-tabstrip-items-wrapper .k-item:hover {\n  outline: 2px solid var(--selecte-row-color) !important;\n  outline-offset: -3px;\n  border-radius: 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
